import React from 'react';
import Box from '@mui/material/Box';
import {
  Categories,
  FeaturedProducts,
  Hero,
  // LatestProducts,
  News,
  Newsletter,
  Overview,
  Products,
  QuickSearch,
  Reviews,
} from './components';
import { AppBar, Button } from '@mui/material';
import GeneralAppBar from '../../Components/GeneralAppBar';

export const Container = ({ children, ...rest }) => (
  <Box
    maxWidth={{ sm: 720, md: 1236 }}
    width={1}
    margin={'0 auto'}
    paddingX={2}
    paddingY={{ xs: 4, sm: 6, md: 8 }}
    {...rest}
  >
    {children}
  </Box>
);

const Ecommerce = () => {
  return (
    <>
      <GeneralAppBar />
      <Box sx={{ mt: 6 }}></Box>
      <Container>
        <Hero />
      </Container>
      <Container>
        <Overview />
      </Container>
      <Container>
        <Categories />
      </Container>
      <Box bgcolor={'secondary.main'}>
        <Container>
          <FeaturedProducts />
        </Container>
      </Box>
      <Container>
        <Products />
      </Container>
      <Box bgcolor={'alternate.main'}>
        <Container>
          <News />
        </Container>
      </Box>
      <Container>
        {/* <LatestProducts /> */}
      </Container>
      <Container paddingTop={'0 !important'}>
        <QuickSearch />
      </Container>
      <Box bgcolor={'alternate.main'}>
        <Container>
          <Reviews />
        </Container>
      </Box>
      <Container>
        <Newsletter />
      </Container>
    </>
  );
};

export default Ecommerce;
